import {createUniversalFetch} from '#imports';

const universalFetch = createUniversalFetch({baseURL: '/'});

export async function uploadFiles(dropedFiles: File[]): Promise<string[]> {
    try {
        const filesId = await Promise.all(
            dropedFiles.map((file) => {
                const fileData = new FormData();

                fileData.append('file', file);
                return universalFetch<string>('/upload-simple', {
                    body: fileData,
                    method: 'post',
                    headers: {Accept: 'text/plain'},
                });
            }),
        );

        return filesId;
    } catch (e) {
        return Promise.reject(e);
    }
}
